import { Link } from "react-router-dom";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid2";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import CloudDiagramsPreview from "../../../assets/clouddiagrams/dashboard-preview.jpg";
import { useCustomerContext } from "../../../Context/CustomerContext";
import { useFullScreen } from "../../../utils/dialog";
import useSegmentTrackEvent from "../../../utils/useSegmentTrackEvent";
import AvailabilityChips from "./AvailabilityChips";
import IntroTour from "./IntroTour";

const DefaultPage = () => {
  const { customer } = useCustomerContext();
  const { isMobile } = useFullScreen();
  const { trackEvent } = useSegmentTrackEvent({ allowNullUser: false });

  const handleCreateDiagramClick = () => {
    trackEvent("Clouddiagrams Create Diagram Clicked", {
      pageType: "Governance",
      pageSubType: "CloudDiagrams",
      feature: "CloudDiagrams",
      isPageOpenEvent: false,
    });
  };

  return (
    <Box>
      <Container maxWidth="lg" sx={{ pb: 8, mt: 4 }}>
        <Grid
          container
          spacing={12}
          sx={{
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Grid size={{ sm: 12, md: 6 }}>
            <Box>
              <Typography
                variant="h1"
                sx={{ fontSize: "36px", lineHeight: "44px", mb: "6px" }}
                data-cy="clouddiagrams-title"
              >
                Visualize your cloud infrastructure in real-time
              </Typography>
              <Stack direction="row" spacing={1}>
                <AvailabilityChips />
              </Stack>
              <Typography variant="body1" sx={{ m: "26px 0" }}>
                Cloud Diagrams creates an always up-to-date visual map of your cloud infrastructure, enabling faster
                incident resolution, better change management, and enhanced cross-team collaboration
              </Typography>
              <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
                {!isMobile && (
                  <Button
                    variant="contained"
                    color="primary"
                    component={Link}
                    to={`/customers/${customer.id}/analyze/cloud-diagrams/onboarding`}
                    data-cy="clouddiagrams-create-first-diagram"
                    onClick={handleCreateDiagramClick}
                  >
                    Create your first diagram
                  </Button>
                )}
                <Button
                  variant="outlined"
                  color="primary"
                  startIcon={<OpenInNewIcon />}
                  component={"a"}
                  href="https://help.doit.com/docs/governance/cloud-diagrams/create"
                  data-cy="clouddiagrams-learn-more"
                >
                  Learn more
                </Button>
              </Stack>
            </Box>
          </Grid>
          <Grid size={{ sm: 12, md: 6 }}>
            <Card sx={{ width: "100%", height: "auto" }}>
              <CardMedia
                component="img"
                image={CloudDiagramsPreview}
                alt="Cloud Diagrams Preview"
                sx={{
                  width: "100%",
                  height: "auto",
                  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.15)",
                }}
                data-cy="clouddiagrams-preview-image"
              />
            </Card>
          </Grid>
        </Grid>
      </Container>
      <IntroTour />
    </Box>
  );
};

export default DefaultPage;
